// Product catalog — sourced from the original framer site.
// User asked for the "Pack jugador de fútbol" (160€) to appear first.

export const PRODUCTS = [
  {
    slug: "pack-jugador-futbol",
    name: "Pack jugador de fútbol",
    category: "Pack",
    featured: true,
    price: 160,
    oldPrice: 199.9,
    images: [
      "https://framerusercontent.com/images/TobFAIRbtuhzMXraeEixUu7LbY.png?width=1600",
      "https://framerusercontent.com/images/1CPMJXzxsccAD0XfebXcppjsEg.png?width=1600",
    ],
    short: "El kit completo del jugador de La Bombonera.",
    includes: [
      "2 camisetas de entreno",
      "1 short oficial",
      "1 par de medias oficiales",
      "1 chándal",
    ],
    badges: ["Devolución 30 días", "Envío gratuito", "Garantía"],
  },
  {
    slug: "camiseta-oficial-blanca",
    name: "Camiseta oficial blanca",
    category: "Camisetas",
    price: 44.9,
    oldPrice: 59.9,
    images: [
      "https://framerusercontent.com/images/4SRThPiJyTUIebFCiH4upZAY.jpg?width=1600",
      "https://framerusercontent.com/images/3IcUFmB35RogPvTrpNG81HdPo.jpg?width=1600",
    ],
    short: "Visitante 25/26. Personalizable con nombre y número.",
    badges: ["Devolución 30 días", "Envío gratuito", "Garantía"],
  },
  {
    slug: "camiseta-oficial-azul",
    name: "Camiseta oficial azul",
    category: "Camisetas",
    price: 44.9,
    oldPrice: 59.9,
    images: [
      "https://framerusercontent.com/images/e76uldAM2BNcat6kgsapxN28.jpg?width=1600",
      "https://framerusercontent.com/images/3IcUFmB35RogPvTrpNG81HdPo.jpg?width=1600",
    ],
    short: "Local 25/26. Los colores históricos del club.",
    badges: ["Devolución 30 días", "Envío gratuito", "Garantía"],
  },
  {
    slug: "camiseta-entreno-azul",
    name: "Camiseta de entreno azul",
    category: "Camisetas",
    price: 39.9,
    oldPrice: 59.9,
    images: [
      "https://framerusercontent.com/images/1CPMJXzxsccAD0XfebXcppjsEg.png?width=1600",
    ],
    short: "Tejido técnico, transpirable, listo para entrenar.",
    badges: ["Devolución 30 días", "Envío gratuito", "Garantía"],
  },
  {
    slug: "short-oficial",
    name: "Short oficial",
    category: "Short",
    price: 24.9,
    oldPrice: 39.9,
    images: [
      "https://framerusercontent.com/images/1CPMJXzxsccAD0XfebXcppjsEg.png?width=1600",
    ],
    short: "Cómodo, ligero, con escudo bordado.",
    badges: ["Devolución 30 días", "Envío gratuito", "Garantía"],
  },
];

export const findProductBySlug = (slug) =>
  PRODUCTS.find((p) => p.slug === slug);

export const formatPrice = (n) =>
  `${n.toString().replace(".", ",")}€`;
